import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { cn } from "@/lib/utils";

const buttonGroupVariants = cva(
	"flex [&>*:not(:last-child):not(:first-child)]:rounded-none",
	{
		variants: {
			orientation: {
				horizontal:
					"*:-mr-px flex-row [&>*:first-child]:rounded-e-none [&>*:last-child]:rounded-s-none",
				vertical:
					"*:-mb-px flex-col [&>*:first-child]:rounded-b-none [&>*:last-child]:rounded-t-none",
			},
			variants: {
				line: "[&.flex-col>*:not(:first-child)]:border-t [&.flex-row>*:not(:first-child)]:border-s",
			},
		},
		defaultVariants: {
			orientation: "horizontal",
		},
	}
);

const ButtonGroupItem = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
	<div
		className={cn("flex items-center rounded border bg-accent px-4", className)}
		ref={ref}
		{...props}
	/>
));
ButtonGroupItem.displayName = "ButtonGroupItem";

interface ButtonGroupProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof buttonGroupVariants> {}

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
	({ className, orientation, variants, ...props }, ref) => (
		<div
			className={cn(
				buttonGroupVariants({
					orientation,
					variants,
					className,
				})
			)}
			ref={ref}
			{...props}
		/>
	)
);
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup, ButtonGroupItem };
